import React, { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import QueryString from "query-string";
// import uuid from "uuid";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

import pageTitle from "../utils/pageTitle";
// import history from "../store/history";
import { loginUser } from "../store/actions/auth";
import Axios from "../utils/axios";
import { AUTH_LOGIN_URL } from "../config";
import { decodeJwt } from "../utils/jwt";
import SubmitButton from "../components/button/SubmitButton";
import { showErrorAlert } from "../store/actions/alerts";

import { getSessionId } from "../utils/storage"

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link
        color="inherit"
        target="_blank"
        href="https://www.travalour.com/"
        underline="none"
      >
        Travalour.com
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

export default function Login({ location }) {
  pageTitle("Login");
  const dispatch = useDispatch();
  const auth = useSelector(store => store?.auth);
  const classes = useStyles();

  useEffect(() => {
    if (auth?.accessToken) {
      const query = QueryString.parse(location.search);
      const returnUrl = query?.retUrl;

      // *** history.push("/dashboard"); <-- creating issue with access control. so force refreshing ***
      if (returnUrl) {
        window.location = returnUrl;
      } else {
        window.location = "/";
      }
    }
    // eslint-disable-next-line
  }, [auth]);

  const onSubmit = (values, { setSubmitting, setFieldValue }) => {
    setSubmitting(true);
    const axiosInstance = new Axios("public");

    axiosInstance
      .request({
        url: AUTH_LOGIN_URL.url,
        method: AUTH_LOGIN_URL.method,
        data: {
          username: values.username,
          password: values.password,
          // sessionId: uuid.v4()
          sessionId: getSessionId()
        }
      })
      .then(async response => {
        const user = response.data;
        const decoded = decodeJwt(user.accessToken);
        // console.log(user);
        dispatch(
          loginUser({
            ...user,
            // acl: [...(user.acl)],
            expiry: decoded.exp,
            sessionId: decoded.ses,
            isRefreshing: false
          })
        );

        // *** LOGIN HAPPENS IN THE useEffect ABOVE ***
      })
      .catch(error => {
        dispatch(
          showErrorAlert(
            !!error.response
              ? `${error.response.status}! - ${error.response.data.errorMessage}`
              : error.message
          )
        );
        setFieldValue("password", "");
        setSubmitting(false);
      });
  }


  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Login
        </Typography>

        <Formik
          initialValues={{ username: "", password: "" }}
          onSubmit={onSubmit}
          validationSchema={Yup.object().shape({
            username: Yup.string().required("Username Required!"),
            password: Yup.string().required("Password Required!")
          })}
        >
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit
            } = props;
            return (
              <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="username"
                  label="Username"
                  name="username"
                  autoComplete="username"
                  value={values.username}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={
                    touched.username && errors.username && errors.username
                  }
                  error={!!touched.username && !!errors.username}
                  disabled={isSubmitting}
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={
                    touched.password && errors.password && errors.password
                  }
                  error={!!touched.password && !!errors.password}
                  disabled={isSubmitting}
                />
                <SubmitButton
                  fullWidth
                  className={classes.submit}
                  disabled={isSubmitting}
                  isSubmitting={isSubmitting}
                  autoFocus
                >
                  Login
                </SubmitButton>
              </form>
            );
          }}
        </Formik>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
